import { createTypes, createActions, createReducer } from './util'
import _ from 'lodash/fp'

const namespace = 'buddies'

const typeKeys = [
  'RESET',
  'SET'
]

export const types = createTypes(typeKeys, namespace)

export const actions = createActions(types)

const initialState = {
  // id -> { id, name, img }
}

const reducer = {
  [types.RESET]: p => _.constant(initialState),
  [types.SET]: p => s => _.keyBy('id', p)
}

export default createReducer(initialState, reducer)

function createSelectors () {
  return {
    getBuddies: _.get(namespace)
  }
}

export const selectors = createSelectors()
